module.exports = __webpack_public_path__ + "static/media/affiliate-tutorial-step-5.7e138359.webp";